import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import About from "@/components/About";
import TwoSides from "@/components/TwoSides";
import AreaShowcase from "@/components/AreaShowcase";
import BookGuide from "@/components/BookGuide";
import Expertise from "@/components/Expertise";
import Testimonials from "@/components/Testimonials";
import ContactForm from "@/components/ContactForm";
import Footer from "@/components/Footer";

export default function Landing() {
  return (
    <main data-testid="landing-page" className="bg-bone">
      <Navbar />
      <Hero />
      <About />
      <BookGuide />
      <AreaShowcase />
      <TwoSides />
      <Expertise />
      <Testimonials />
      <ContactForm />
      <Footer />
    </main>
  );
}
